import styles from './ZoinkLogo.module.scss';
import zoinkLogo from '../../images/zoinkLogo.svg';

function ZoinkLogo() {
  return <img src={zoinkLogo} className={styles.zoinkWrapper} alt="Zoinks!" />;
}

export default ZoinkLogo;
